import React from 'react';
import { func, object, string } from 'prop-types';
import { Button } from '@mui/material';
import { I18n } from 'utils/i18n';

const DiscardButton = ({ type, onClick, sx = {} }) => (
  <Button
    type={type}
    onClick={onClick}
    sx={theme => ({
      fontSize: '15px',
      color: theme.palette.secondary.main,
      ...sx,
    })}
  >
    {I18n.t('AcknowledgementCreate.Discard')}
  </Button>
);
DiscardButton.propTypes = {
  type: string.isRequired,
  onClick: func.isRequired,
  sx: object,
};

export default DiscardButton;
